// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Input_wrapper__1gAj8","search":"Input_search__2_0EW","input":"Input_input__M4Os-","message":"Input_message__zF9o-","checkbox":"Input_checkbox__3j7hT"};